module.exports = __webpack_public_path__ + "static/gh-2-16e5e03b8c2c4070fe8d62935ed922c1.jpg";